import { Title, Text, SelectorOptionsContainer, SelectorOption } from "../styles";

import { iconMap } from "../../assets/icons";

const Other = () => {
  const itens = [
    { title:"Trabalhe conosco", text:"Canal exclusivo para vagas", icon:"mala", link:`https://mitrerealty.gupy.io/` },
    { title:"Fornecedores", text:"Seja um fornecedor da Mitre", icon:"shake_hands", link:`https://www.mitrerealty.com.br/fornecedores` },
    { title:"Seja um Parceiro Mitre​", text:"Seja um corretor ou imobiliária parceira da Mitre.​", icon:"star", link:`https://www.mitrerealty.com.br/seja-parceiro-mitre` },
    { title:"Outros assuntos", text:"Entre em contato com a Mitre", icon:"question_mark_circle", link:`https://www.mitrerealty.com.br/contato` }
  ];

  return (
    <div>

      <Title>
        Outros assuntos
      </Title>

      <Text>
        Selecione uma das opções a seguir:
      </Text>

      <SelectorOptionsContainer>
        { itens.map((item) => (
            <a 
              key={ item.title } 
              href={ item.link }
              target="_blank" rel="noreferrer"
            >
              <SelectorOption >
                <div>
                  <h3>{ item.title }</h3>
                  <p>{item.text}</p>
                </div>

              <img
                alt=""
                aria-hidden="true"
                height={ 26 }
                src={ iconMap[item.icon] }
                width={ 26 }
              />
              </SelectorOption>
            </a>
        ))}
      </SelectorOptionsContainer>

    </div>
  )
}

export default Other; 